import { render } from "./VignetteCategoryPricingTable.vue?vue&type=template&id=d13093ea"
import script from "./VignetteCategoryPricingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VignetteCategoryPricingTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/VignetteCategoryPricingTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d13093ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d13093ea', __exports__)) {
    api.reload('d13093ea', __exports__)
  }
  
  module.hot.accept("./VignetteCategoryPricingTable.vue?vue&type=template&id=d13093ea", () => {
    api.rerender('d13093ea', render)
  })

}


export default __exports__